module.exports = __webpack_public_path__ + "static/media/ayo-ogunseinde-1.6ef33d09.jpg";